// The backend rotates refresh tokens on every use and blacklists the one
// just spent (SIMPLE_JWT ROTATE_REFRESH_TOKENS + BLACKLIST_AFTER_ROTATION).
// A second open tab (or a native app instance alongside the browser) can
// send that same soon-to-be-blacklisted token at nearly the same moment and
// lose the race. Rather than fail that race outright, wait briefly for
// localStorage to show the token has since been rotated by whoever won,
// then use the access token that rotation already produced.
export function waitForTokenRotatedElsewhere(staleRefreshToken, { timeoutMs = 2000, intervalMs = 150 } = {}) {
  return new Promise((resolve) => {
    const deadline = Date.now() + timeoutMs;
    const check = () => {
      if (localStorage.getItem('refreshToken') !== staleRefreshToken) {
        resolve(localStorage.getItem('accessToken'));
        return;
      }
      if (Date.now() >= deadline) {
        resolve(null);
        return;
      }
      setTimeout(check, intervalMs);
    };
    check();
  });
}
